import styled, { css } from 'styled-components';
import { MBlockquoteAlignment } from './MBlockquote.types';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

export const MBlockquoteWrapper = styled.div<{
  alignment?: MBlockquoteAlignment;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  row-gap: ${spacers?.spacers?.[2] ?? '0.5rem'};

  ${props =>
    props.alignment === MBlockquoteAlignment.Centered &&
    css`
      align-items: center;
      text-align: center;
    `}
`;
